if(jQuery('.post-type-archive-propiedad').length ) {
    var windowsize = jQuery(window).width();        
    if (windowsize <= 768) {     
        jQuery('#sidebar').slideToggle();

        jQuery(document).on('click', '.filter-collapse', function(e) {
            e.stopPropagation();
            e.preventDefault();                
            if (e.target !== this)
                return;
            jQuery('#sidebar').slideToggle();
        });
    }
  
}